import { useQuery } from '@tanstack/react-query'
import { dashboardService } from '@/services/dashboard.service'

export const useDashboard = () => {
  return useQuery({
    queryKey: ['dashboard-summary'],
    queryFn: () => dashboardService.getSummary(),
    staleTime: 30000,
    refetchInterval: 60000
  })
}
